import React, { FC } from "react";

interface AiCompareType {
    others: string[];
    gallabox: string[];
}

const TableEntry: FC<{ entries: string[]; strikeThrough?: boolean }> = ({ entries, strikeThrough = false }) => {
    return (
        <>
            {entries.map((entry, index) => (
                <tr key={index}>
                    <td className={`px-2 py-4 text-center ${strikeThrough ? "line-through" : ""}`}>{entry}</td>
                </tr>
            ))}
        </>
    );
};

const AiCompareComponent: FC<AiCompareType> = ({ others, gallabox }) => {
    return (
        <div className="px-4 lg:px-0 mx-auto max-w-6xl">
            <h2 className="pb-8 lg:text-4xl text-2xl text-center pt-10 font-bold">
                <span className="text-gray-700">An Intuitive </span>
                <span className="text-blue-500">Gen AI Feature</span>
                <span className="text-gray-700"> with… </span>
            </h2>
            <div className="relative w-full pt-10 max-w-6xl mx-auto ">
                <img
                    loading="lazy"
                    className="w-20 h-20 absolute lg:block hidden"
                    style={{ left: "10%", top: "-3%", zIndex: 1 }}
                    src="https://assets.gallabox.com/gb-home/ai/emoji1.png"
                    alt="Emoji 1"
                />
                <img
                    loading="lazy"
                    className="w-20 h-20 absolute lg:block hidden"
                    style={{ right: "10%", top: "-3%", zIndex: 1 }}
                    src="https://assets.gallabox.com/gb-home/ai/emoji3.png"
                    alt="Emoji 3"
                />
                <div className="flex justify-center gap-20 flex-wrap">
                    <div className="bg-gray-400 rounded-xl w-96 relative">
                        <div>
                            <p className="lg:text-2xl text-base text-center text-white pt-4">Your Usual AI Tools</p>
                            <img
                                loading="lazy"
                                className="w-20 h-20 absolute block lg:hidden"
                                style={{ right: "1%", top: "-10%", zIndex: 1 }}
                                src="https://assets.gallabox.com/gb-home/ai/emoji1.png"
                                alt="Emoji 1"
                            />
                            <table className="my-5">
                                <tbody className="bg-gray-50">
                                    <TableEntry entries={others} />
                                </tbody>
                                <img
                                    loading="lazy"
                                    className="absolute w-20 h-20 left-1/2 bottom-0"
                                    style={{ left: "50%", transform: "translateX(-50%) translateY(50px)", zIndex: 1 }}
                                    src="https://assets.gallabox.com/gb-home/ai/emoji2.png"
                                    alt="Emoji 2"
                                />
                            </table>
                        </div>
                    </div>
                    <div className="bg-blue-400 rounded-xl w-96 relative shadow-2xl">
                        <div>
                            <p className="lg:text-2xl text-base text-center text-white pt-4">The Gallabox Approach</p>
                            <table className="my-5">
                                <tbody className="bg-blue-50">
                                    <TableEntry entries={gallabox} />
                                </tbody>
                                <img
                                    loading="lazy"
                                    className="w-20 h-20 absolute lg:hidden block"
                                    style={{ right: "1%", top: "-10%", zIndex: 1 }}
                                    src="https://assets.gallabox.com/gb-home/ai/emoji3.png"
                                    alt="Emoji 3"
                                />
                                <img
                                    loading="lazy"
                                    className="absolute w-20 h-20 left-1/2 bottom-0"
                                    style={{ left: "50%", transform: "translateX(-50%) translateY(50px)", zIndex: 1 }}
                                    src="https://assets.gallabox.com/gb-home/ai/emoji4.png"
                                    alt="Emoji 4"
                                />
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AiCompareComponent;
